function includes(coll, el) {
    return coll.includes(el);
}
export class SmartphotoDeductibleInfo {
    static DEDUCTIBLE_TYPES = ['rear', 'front', 'right', 'left', 'roof'];
    taxValue;
    deductibleMargin;
    reports = [];
    allSides;
    constructor(reports, taxValue, deductibleMargin, roof) {
        this.taxValue = taxValue;
        this.deductibleMargin = deductibleMargin;
        this.allSides = roof === 'own_side' ? ['front', 'rear', 'left', 'right', 'roof'] : ['front', 'rear', 'left', 'right'];
        this.reports = reports;
    }
    getOrderedReports() {
        return this.reports
            .filter((r) => r.damages.length > 0 && includes(SmartphotoDeductibleInfo.DEDUCTIBLE_TYPES, r.type))
            .sort((a, b) => b.getTotalCost() - a.getTotalCost());
    }
    getRecommendedLimit() {
        const orderedReports = this.getOrderedReports();
        if (orderedReports.length === 0) {
            return {
                total: 0,
                base: 0,
                tax: 0,
                margin: { rate: 0, value: 0 }
            };
        }
        const base = orderedReports[0].getTotalCost();
        const tax = (base * this.taxValue) / 100;
        const margin = ((base + tax) * this.deductibleMargin) / 100;
        return {
            base,
            tax,
            margin: {
                rate: this.deductibleMargin,
                value: margin
            },
            total: base + tax + margin
        };
    }
    getMainPiece() {
        const [mainReport] = this.getOrderedReports();
        if (!mainReport) {
            return null;
        }
        const { type, damages } = mainReport;
        if (includes(SmartphotoDeductibleInfo.DEDUCTIBLE_TYPES, type)) {
            return damages.length > 0 ? type : null;
        }
        throw new Error('Main report type is not a deductible type');
    }
    getDamages() {
        return this.getOrderedReports().flatMap(({ damages }) => damages);
    }
    add(report) {
        this.reports.push(report);
    }
    getAllSides() {
        return this.allSides;
    }
    getAvailableSides() {
        const usedSides = this.getOrderedReports()
            .filter(({ damages }) => damages.length > 0)
            .map((report) => report.type);
        return this.allSides.filter((side) => !usedSides.includes(side));
    }
}
